import { Group, Text, UnstyledButton, type TextProps } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { IconCheck, IconCopy } from '@tabler/icons-react';

const SIZE_MAP = {
  xs: 8,
  sm: 14,
  md: 20,
  lg: 24,
  xl: 30,
} as const;

export function CopyText({
  children,
  ...textProps
}: TextProps & { children: string }) {
  const clipboard = useClipboard({ timeout: 1500 });

  const size = SIZE_MAP?.[textProps.size as keyof typeof SIZE_MAP] ?? 12;
  return (
    <UnstyledButton onClick={() => clipboard.copy(children)}>
      <Group gap={4} wrap="nowrap" c={clipboard.copied ? 'green' : 'black'}>
        <Text {...textProps}>{children}</Text>
        {clipboard.copied ? (
          <IconCheck size={size} />
        ) : (
          <IconCopy size={size} />
        )}
      </Group>
    </UnstyledButton>
  );
}
